export const getDefaultState = () => {
  return {
    sectionsOrder: [],
  };
};
export const state = getDefaultState();
